import React, { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import { Container, Spinner, Alert } from 'reactstrap'
import { fetchBlogPost } from '../../helpers/blogApi'
import BlogDetail from './BlogDetail'

const BlogPreview = () => {
    const { slug } = useParams()
    const [previewData, setPreviewData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    const PREVIEW_TOKEN = process.env.REACT_APP_STRAPI_PREVIEW_TOKEN

    useEffect(() => {
        const loadPreviewData = async () => {
            try {
                setLoading(true)
                setError(null)

                if (!PREVIEW_TOKEN) {
                    console.error('BlogPreview: Strapi Preview Token is missing.')
                    setError('Authorization configuration error. REACT_APP_STRAPI_PREVIEW_TOKEN is missing in .env')
                    return
                }

                const data = await fetchBlogPost(slug, {
                    publicationState: 'preview',
                    previewToken: PREVIEW_TOKEN
                })

                if (!data) {
                    setError('Draft article not found. Please check the slug.')
                } else {
                    setPreviewData(data)
                }
            } catch (err) {
                console.error('BlogPreview: Error fetching preview data:', err)
                const status = err.response?.status
                const message = err.response?.data?.error?.message || err.message

                if (status === 401 || status === 403) {
                    setError(`Permission denied (${status}). Your preview token might be invalid or lacks permissions.`)
                } else if (status === 404) {
                    setError(`Article not found (404). Check the slug: ${slug}`)
                } else {
                    setError(`Failed to load preview: ${message}`)
                }
            } finally {
                setLoading(false)
            }
        }

        if (slug) {
            loadPreviewData()
        }
    }, [slug, PREVIEW_TOKEN])

    if (loading) {
        return (
            <div className="page-content">
                <Container fluid>
                    <div className="text-center py-5">
                        <Spinner color="primary" />
                        <p className="mt-3">Loading draft content...</p>
                    </div>
                </Container>
            </div>
        )
    }

    if (error) {
        return (
            <div className="page-content">
                <Container fluid>
                    <Alert color="danger" className="mb-4">
                        <h4 className="alert-heading">Preview Error</h4>
                        <p>{error}</p>
                        <hr />
                        <p className="mb-0">
                            Check if the slug <code>{slug}</code> is correct and that your preview token is valid.
                        </p>
                    </Alert>
                    <Link to="/blog" className="btn btn-primary">
                        ← Back to Blog
                    </Link>
                </Container>
            </div>
        )
    }

    return <BlogDetail previewData={previewData} />
}

export default BlogPreview
